import styled from '@emotion/styled';

export const StyledResources = styled.div`
  width: 100%;
`;
